import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ErrorWrapper } from './ErrorFallback.style';
import Icon from '@mlb/react-patterns/components/Icon/icon';
import Button from '@mlb/react-patterns/components/Button/button';
import { ButtonStyles, ButtonShapes } from '@mlb/react-patterns/components/Button/button.types';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import { useTheme } from '@gameday/utils/hooks/useTheme';
import COLORS from '@mlb/react-patterns/style/universal.color';

const { mlbBlack, mlbWhite } = COLORS;
const { SOLID } = ButtonShapes;
const { LINK_BLUE } = ButtonStyles;

const ErrorFallback = ({
    paddingOverride,
    marginOverride,
    error,
    width,
    resetErrorBoundary,
    componentStack,
    componentName,
    showButton,
    buttonText,
    horizontal,
    customMessage,
    customDictKey,
    isButtonDisabled,
    buttonShape,
    buttonStyle
}) => {
    const resetErrorBoundaryHandler = useMemo(() => {
        return {
            onClick: resetErrorBoundary
        };
    }, [resetErrorBoundary]);
    const theme = useTheme();
    let baseballFill = '';

    if (theme === 'dark') {
        baseballFill = mlbWhite;
    } else {
        baseballFill = mlbBlack;
    }

    const dictKey = customDictKey || 'component_error_message';
    const message = customMessage || 'Sorry, there was a problem loading the {componentName} component. Please try again.';
    const errorText = useTranslator(dictKey, message, { componentName });

    return (
        <ErrorWrapper
            paddingOverride={paddingOverride}
            marginOverride={marginOverride}
            horizontal={horizontal}
            disabled={isButtonDisabled}
        >
            <Icon name='sad-baseball' width={width || 64} fill={baseballFill} />
            <p>{errorText}</p>
            {showButton &&
                <Button
                    handlers={resetErrorBoundaryHandler}
                    ariaLabel={'Reset error'}
                    shape={buttonShape ?? SOLID}
                    styleName={buttonStyle ?? LINK_BLUE}
                    disabled={isButtonDisabled}
                >{buttonText}</Button>
            }
        </ErrorWrapper>
    );
};

ErrorFallback.propTypes = {
    showButton: PropTypes.bool,
    buttonText: PropTypes.string,
    resetErrorBoundary: PropTypes.func,
    componentName: PropTypes.string,
    error: PropTypes.any,
    componentStack: PropTypes.any,
    paddingOverride: PropTypes.string,
    marginOverride: PropTypes.string,
    horizontal: PropTypes.bool,
    width: PropTypes.number,
    customMessage: PropTypes.string,
    customDictKey: PropTypes.string,
    isButtonDisabled: PropTypes.bool
};

export default ErrorFallback;
